const list = {
    path: 'notAccountMerchant',
    component: resolve => require(['@/pages/admin/aftersales/notAccountMerchant'], resolve)
}

export default list
